export const defaultSliderSettings = {
	centerMode: false,
	infinite: false,
	row: 1
};
